import React from 'react';
import { Modal } from 'antd';
import styled from '@emotion/styled';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { TitleModal } from '../../molecules/modal/TitleModal';
import { appStyles } from '../../../styles';
import { FormTourStory } from './forms/FormTourStory';
import { TOUR_STORIES } from '../../../constants/define/translation';

interface FormTourStoryModalProps {
  isOpenModal: boolean;
  onClose: () => void;
  record?: any;
  onRefresh: () => void;
  setDataRecord: Function;
  sortOrderMax: number;
}

export const FormTourStoryModal = (props: FormTourStoryModalProps) => {
  const { isOpenModal, onClose, record, onRefresh, setDataRecord, sortOrderMax } = props;
  const { t } = useTranslation(TOUR_STORIES);
  return (
    <StyledModal
      title={<TitleModal title={t('form.createTourStory')} />}
      centered
      visible={isOpenModal}
      width={500}
      footer={null}
      onCancel={() => {
        onClose();
        setDataRecord(null);
      }}
      maskClosable={false}
      closeIcon={<CloseCircleOutlined />}
      forceRender
    >
      <FormTourStory
        sortOrderMax={sortOrderMax}
        setDataRecord={setDataRecord}
        onCloseModal={onClose}
        onRefresh={onRefresh}
        record={record}
      />
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  & > .ant-modal-content {
    ${appStyles.commonModalContentStyle}
  }

  .site-card-wrapper {
    ${appStyles.background.modalBgGray}
    & .card-item {
      text-align: center;
      padding: 1rem;
    }
  }

  & h4.ant-typography {
    ${appStyles.color.black}
  }

  .ant-modal-header {
    padding-left: 0;
  }

  .card-item .ant-image {
    cursor: pointer;
  }

  & .card-up-to-date {
    & .ant-image {
      padding: 0px;
      margin-left: 12px;
      & img {
        width: 92%;
        padding: 5px 0 0px 0;
      }
    }
  }
`;
